import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

// 【優化】解決 Vue Router 3.x 路由重複點擊報錯問題（NavigationDuplicated）
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const router = new Router({
  // mode: 'history', // 如果後端有設定好可以開啟
  routes: [
    {
      path: "/",
      redirect: "/homewarning"
    },
    {
      path: "/homewarning",
      name: "homewarning",
      component: () => import("./components/HomeView/HomeWarningView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/home",
      name: "home",
      component: () => import("./components/HomeView/HomeView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/acyear",
      name: "acyear",
      component: () => import("./components/Ac/AcyearView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/acsummer",
      name: "acsummer",
      component: () => import("./components/Ac/AcsummerView.vue").catch(err => {
        alert("載入失敗: " + err.message);
      }),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/category", //分類
      name: "category",
      component: () => import("./components/CategoryView/CategoryView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/categoryvideo", //分類列表
      name: "categoryvideo",
      component: () => import("./components/CategoryView/CategoryVideoView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/buy", //購買
      name: "buy",
      component: () => import("./components/BuyView/BuyView.vue"),
      meta: {
        keepAlive: false //不需要被緩存的組件
      }
    },
    {
      path: "/nav", //導航
      name: "nav",
      component: () => import("./components/NavView/NavView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/mine", //我的
      name: "mine",
      component: () => import("./components/MineView/MineView.vue"),
      meta: {
        keepAlive: false //不需要被緩存的組件
      }
    },
    {
      path: "/searchindex", //索引
      name: "searchindex",
      component: () => import("./components/SearchIndexView/SearchIndexView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/videodetail",
      name: "videodetail",
      component: () => import("./components/VideoDetailView/VideoDetailView.vue"),
      meta: {
        keepAlive: false //不需要被緩存的組件
      }
    },
    {
      path: "/videodetailx",
      name: "videodetailx",
      component: () => import("./components/VideoDetailView/VideoDetailPreloadView.vue"),
      meta: {
        keepAlive: false //不需要被緩存的組件
      }
    },
    {
      path: "/searchvideo",
      name: "searchvideo",
      component: () => import("./components/SearchVideoView/SearchVideoView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/avtop",
      name: "avtop",
      component: () => import("./components/AvTopView/AvTopView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/articlecontent",
      name: "articlecontent",
      component: () => import("./components/ArticleListView/ArticleContentView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/article_search",
      name: "article_search",
      component: () => import("./components/ArticleListView/ArticleSearchView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/article",
      name: "article",
      component: () => import("./components/ArticleListView/ArticleView.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/login",
      name: "login",
      component: () => import("./components/LoginView/LoginView.vue"),
      meta: {
        keepAlive: false //不需要被緩存的組件
      }
    },
    {
      path: "/login1",
      name: "login1",
      component: () => import("./components/LoginView/LoginView1.vue"),
      meta: {
        keepAlive: false //不需要被緩存的組件
      }
    },
    {
      path: "/register",
      name: "register",
      component: () => import("./components/RegisterView/RegisterView.vue"),
      meta: {
        keepAlive: false //不需要被緩存的組件
      }
    },
    {
      path: "/csr",
      name: "csr",
      component: () => import("./components/CsrView/CsrView.vue"),
      meta: {
        keepAlive: false //不需要被緩存的組件
      }
    },
    {
      path: "/month299",
      name: "month299",
      component: () => import("./components/Month299View/Month299View.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/month499",
      name: "month499",
      component: () => import("./components/Month499View/Month499View.vue"),
      meta: {
        keepAlive: true //需要被緩存的組件
      }
    },
    {
      path: "/history",
      name: "history",
      component: () => import("./components/HistoryView/HistoryView.vue"),
      meta: {
        keepAlive: true, //需要被緩存的組件
        isBack: false //回上頁存
      }
    },
    {
      path: "/like",
      name: "like",
      component: () => import("./components/LikeListView/LikeListView.vue"),
      meta: {
        keepAlive: true, //需要被緩存的組件
        isBack: false //回上頁存
      }
    },
    {
      path: "/casino",
      name: "casino",
      component: () => import("./components/CasinoView/CasinoView.vue"),
      meta: {
        keepAlive: true, //需要被緩存的組件
        isBack: false //回上頁存
      }
    },
    {
      path: "/shop",
      name: "shop",
      component: () => import("./components/ShopView/ShopView.vue"),
      meta: {
        keepAlive: false, //不需要被緩存的組件
        isBack: false //回上頁存
      }
    },
    {
      path: "/credit",
      name: "credit",
      component: () => import("./components/CreditView/CreditView.vue"),
      meta: {
        keepAlive: true, //需要被緩存的組件
        isBack: false //回上頁存
      }
    }
  ],

  scrollBehavior(to, from, savedPosition) {
    if (to.fullPath.indexOf('videodetail') !== -1) {
      // 內頁置頂
      return { x: 0, y: 0 };
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// 【修正】將原本誤寫在配置內的 beforeRouteLeave 改寫為正確的全域前置守衛
router.beforeEach((to, from, next) => {
  if (from.meta) {
    // 當準備前往內頁 videodetail 時，將當前頁面緩存打開；去其他頁面則關閉緩存
    if (to.fullPath.indexOf('videodetail') !== -1) {
      from.meta.keepAlive = true;
    } else {
      from.meta.keepAlive = false;
    }
  }
  next(); // 必須呼叫 next() 路由才會繼續執行！
});

export default router;